import { ReactNode } from "react";
import { motion } from "framer-motion";

type LoginBackgroundProps = {
  children?: ReactNode; // Optional children prop
};

export default function LoginBackground({ children }: LoginBackgroundProps) {
  // Framer Motion animation variants
  const backgroundVariants = {
    hidden: { opacity: 0 }, // Initial state: fully transparent
    visible: { opacity: 1 }, // Visible state: fully opaque
  };

  return (
    <motion.div
      variants={backgroundVariants}
      initial="hidden"
      animate="visible"
      transition={{ duration: 1.2, ease: "easeInOut" }} // Smooth fade-in
      className="relative w-full h-screen overflow-hidden bg-cover bg-center bg-[url('/images/bg_img.png')]"
      data-testid="login-background"
    >
      <motion.div
        initial={{ y: 20, opacity: 0 }} // Start slightly below and transparent
        animate={{ y: 0, opacity: 1 }} // Slide into view and become visible
        transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }} // Delayed smooth motion
        className="h-full flex items-center justify-center"
      >
        {children}
      </motion.div>
    </motion.div>
  );
}
